<template>
  <div>
    <!-- <topnav /> -->
    <div class="approve-container">
      <div class="approve-title">
        <router-link to="/tasklist"><button class="hollow-btn">返回</button></router-link>
        <button
          :style="{ background: mode === 0 ? '#cccccc' : '' }"
          @click="finishImage()"
          style="width: 100px;margin-left: 30px;"
        >
          审核通过
        </button>
        <button class="hollow-btn" :disabled="!duoview" style="width: 120px;margin-left: 30px;" @click="showDuoview()">
          查看另一视角
        </button>
        <div class="anno-belonger" v-if="currAnno.annotator && !currAnno.approver">
          <span>创建人：{{ currAnno.annotator }}</span>
          <span>创建时间：{{ new Date(currAnno.createAt).toLocaleString('chinese', { hour12: false }) }}</span>
        </div>
        <div class="image-info">
          <span>图片ID：{{ imageId }}</span>
          <span v-if="role === 'approver'">剩余：{{ taskDetail.annotatedCount }}张</span>
          <span v-else-if="role === 'approverTwo'">剩余：{{ taskDetail.unapprovedTwoImageCount }}张</span>
        </div>
        <div class="mode-btn">
          <button
            v-if="taskTypeId === 5 || taskTypeId === 6"
            class="hollow-btn"
            :class="currMode === 'point' ? 'active' : ''"
            @click="
              point();
              currMode = 'point';
            "
          >
            画框模式
          </button>
          <button
            v-if="taskTypeId === 5 || taskTypeId === 6"
            class="hollow-btn"
            :class="currMode === 'words' ? 'active' : ''"
            @click="
              words();
              currMode = 'words';
            "
            :disabled="orgAnnos.length === 0"
          >
            录入模式
          </button>
        </div>
      </div>
      <div class="approve-content">
        <div class="approve-image">
          <AnnoPanel
            v-if="showPanel"
            :src="url"
            ref="annopanel"
            :annos="annos"
            height="646"
            :style="{ height: taskTypeId !== 3 ? '646px' : '100%', maxHeight: '646px', background: '#fafafa' }"
            :mode="mode"
            scalable
            :separable="taskTypeMap[taskTypeId] !== 2"
            :anno-enable="annoEnable"
            :hidden="taskTypeId !== 3"
            maskColor="transparent"
            @annoClick="annoClick($event)"
          ></AnnoPanel>
          <a class="icp-info" href="https://beian.miit.gov.cn" target="_blank">
            <span>沪ICP备20000777号-1</span>
          </a>
        </div>
        <div class="approve-classes anno-option" v-if="taskTypeId !== 5 && taskTypeId !== 6">
          <div class="category-option" v-for="(item, group) of sortedClassifications" :key="group">
            <span
              class="class-option"
              :class="{ active: currClasses.includes(c.classId), exist: existClasses[c.classId] }"
              v-for="c of item"
              :key="c.classId"
              @click="setClass(0, c.classId)"
            >
              {{ c.className }}{{ existClasses[c.classId] ? `(${existClasses[c.classId]})` : '' }}
            </span>
            <div class="separate-line"></div>
          </div>
        </div>
        <div class="annotate-text anno-option" v-if="taskTypeId === 5 || taskTypeId === 6">
          <textarea v-model="sceneText" :disabled="mode === 1"></textarea>
        </div>
        <div v-show="url" class="approve-btn">
          <div v-if="annoEnable">
            <div v-show="mode === 1">
              <button @click="newAnno()" style="width: 200px;margin: 0px;">新增画框</button>
              <!-- <button class="hollow-btn" @click="invalidImage()">无效</button> -->
            </div>
            <div v-show="mode === 0">
              <button
                class="hollow-btn"
                style="color:#c05d5d;border-color:#c05d5d;width: 200px;display: block;margin-bottom: 18px;"
                @click="rePaint()"
              >
                重画
              </button>
              <button :disabled="saveAnnoAble" style="width: 100px;margin-right: 40px;" @click="saveAnno()">
                保存画框
              </button>
              <button style="background: #c05d5d;width: 60px;" @click="deleteAnno()">
                {{ getDeleteName() }}
              </button>
            </div>
          </div>
          <div v-else>
            <button v-show="mode === 0" @click="saveAnno" style="width: 200px;margin: 0px;">确认</button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="另一视角图片" :visible.sync="duoviewVisible" width="70%">
      <div v-if="duoview" style="text-align: center;">
        <img :src="duoview.url" style="max-width: 100%; max-height: 70vh; object-fit: contain;" />
        <p style="margin-top: 8px; color: #666;">{{ duoview.name }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import topnav from '@/components/topnav';
import * as api from '@/api/api.js';
import ImageDetail from '@/mixins/imagedetail.js';
import { undeterminedClassId } from '@/config';

export default {
  data: function() {
    return {
      wordsIndex: 0,
      orgUrl: '',
      currOperation: 'point',
      currMode: 'point',
      restImageCount: 0,
      imageId: 0,
      url: '',
      taskType: null, // AnnoPanel中的标注类型
      taskTypeId: null, // 服务端返回的标注类型
      annotations: [],
      classifications: [],
      classes: [],
      annos: [],
      orgAnnos: [],
      mode: 1,
      currAnno: {},
      currClasses: [],
      width: 0,
      height: 0,
      saveAnnoAble: false,
      sceneText: '',
      pageType: 'approve',
      hasChange: false,
      imageStatus: 0,
    };
  },
  mixins: [ImageDetail],
  computed: {
    // existClasses() {
    //   return this.orgAnnos.reduce((total, item) => [...total, ...item.classIds], []);
    // },
    existClasses() {
      // 管理员页面每个类别要显示属于该类别的标注数量
      let result = {};
      this.orgAnnos
        .reduce((total, item) => [...total, ...item.classIds], [])
        .forEach(v => {
          result[v] = result[v] ? result[v] + 1 : 1;
        });
      return result;
    },
    sortedClassifications() {
      // return this.classifications.map(clf => {
      //   clf.classes = [
      //     ...clf.classes.filter(cls => this.existClasses[cls.classId]),
      //     ...clf.classes.filter(cls => !this.existClasses[cls.classId]),
      //   ];
      //   return clf;
      // });
      return this.classifications.reduce((pre, cur) => {
        cur.classes.forEach(v => {
          const group = parseInt(v.groupId / 100);
          if (pre[group]) {
            pre[group].push(v);
          } else {
            pre[group] = [v];
          }
        });
        return pre;
      }, {});
    },
  },
  methods: {
    annosFormat() {
      this.orgAnnos = this.annotations.map(anno => {
        let tmpAnno = {
          id: anno.id,
          type: this.taskTypeMap[this.taskTypeId],
          data: anno.points,
          userId: anno.userId,
          annotator: anno.annotatorName,
          createAt: anno.createAt,
          status: anno.annoStatus,
        };
        if (
          this.taskTypeId !== 5 &&
          this.taskTypeName !== '文本矩形' &&
          this.taskTypeId !== 6 &&
          this.taskTypeName !== '文本多边形'
        ) {
          tmpAnno.cat = anno.classes[0].classId;
          tmpAnno.title = anno.classes.map(item => item.className).join(',');
          tmpAnno.classIds = anno.classes.map(item => item.classId);
        } else {
          tmpAnno.words = anno.words;
          tmpAnno.cat = 0;
          tmpAnno.title = anno.words;
          tmpAnno.classIds = [];
        }
        return tmpAnno;
      });
      this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
    },
    updateAnno() {
      if (this.currClasses[0] === undeterminedClassId) {
        this.$message.error('类别不能为待定');
        return;
      }
      if (this.compareAnno() && this.currOperation !== 'words') {
        this.mode = 1;
        this.currClasses = [];
        this.sceneText = '';
        this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
        this.saveAnnoAble = false;
      } else {
        let anno = {
          taskId: this.$route.params.id,
          imageid: this.imageId,
          annotationId: this.currAnno.id,
          points: this.currAnno.data.map(v => v.map(v => v.map(v => Math.round(v)))),
          classIds: this.currClasses,
          hasChange: this.hasChange,
        };
        if (this.taskTypeId === 5 || this.taskTypeId === 6) anno.words = this.sceneText;
        api
          .saveAnno(anno)
          .then(() => {
            let tmpAnno = {
              id: this.currAnno.id,
              type: this.currAnno.type,
              cat: this.currClasses[0],
              title: this.currClasses.map(v => this.classes[v]).join(','),
              classIds: this.currClasses,
              data: this.currAnno.data,
              userId: this.$store.state.userId,
              status: 3,
            };
            if (this.taskTypeId === 5 || this.taskTypeId === 6) {
              tmpAnno.words = this.sceneText;
              tmpAnno.title = this.sceneText;
              tmpAnno.cat = 0;
            }
            this.$set(
              this.orgAnnos,
              this.orgAnnos.findIndex(v => v.id === this.currAnno.id),
              tmpAnno,
            );
            if (this.currOperation !== 'words') {
              this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
              this.mode = 1;
              this.sceneText = '';
              this.currClasses = [];
              this.currAnno = {};
            } else {
              this.nextAnno();
            }
            this.saveAnnoAble = false;
            this.hasChange = false;
          })
          .catch(() => {
            this.saveAnnoAble = false;
            this.hasChange = false;
          });
      }
    },
  },
};
</script>
<style scoped>
button {
  margin: 0px;
  height: 38px;
}
.approve-btn {
  position: absolute;
  right: 0px;
  bottom: 12px;
}
.approve-content {
  height: 646px;
  position: relative;
}
.approve-image {
  box-sizing: border-box;
  margin-right: 224px;
}
.anno-option {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 200px;
  height: 588px;
  padding-top: 10px;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  background: #fafafa;
  overflow: scroll;
}
.annotate-text {
  padding: 0px;
}
.annotate-text textarea {
  resize: none;
  width: 198px;
  height: 586px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 18px;
}
.approve-container {
  padding: 0px 50px 24px;
  width: 100%;
  box-sizing: border-box;
}
.approve-title {
  position: relative;
  margin: 16px 0px;
}
.approve-title button {
  width: 57px;
  height: 30px;
  margin: 0px;
}
.approve-title > div {
  display: inline-block;
}
.approve-title span {
  display: inline-block;
  margin: 0px 18px;
}
.approve-title > .anno-belonger {
}
.approve-title > .image-info {
  position: absolute;
  right: -18px;
}
.class-option {
  display: block;
  cursor: pointer;
  padding: 6px 12px;
  font-size: 14px;
}
.class-option.exist {
  background: rgba(93, 137, 192, 0.15);
}
.class-option.active {
  background: rgba(93, 137, 192, 0.4);
}
.category-option:last-child .separate-line {
  display: none;
}
.separate-line {
  border-top: 1px dashed #bbbbbb;
  margin: 6px;
}
.icp-info {
  display: block;
  padding-top: 12px;
  text-align: center;
  font-size: 14px;
  color: #333333;
}
button.active {
  background-color: #5d89c0;
  color: #ffffff;
}
.mode-btn {
  display: inline-block;
  float: right;
  margin-right: 224px;
}
.mode-btn button {
  margin-left: 20px;
  width: 100px;
  outline: none;
}
.approve-option {
  float: right;
  margin-right: 250px;
}
.approve-classes.anno-option {
  height: 518px;
}
</style>
